export const SELECTION_WORKSPACE_PATH = 'map/selection';
export const SELECTION_WORKSPACE_ROUTE = `/${SELECTION_WORKSPACE_PATH}`;

export type WorkspaceOpenMode = 'windowed' | 'docked-right';

const WORKSPACE_OPEN_MODE_INFO_KEY = 'workspaceOpenMode';

/**
 * Carries a one-navigation opening preference without making layout part of
 * the shareable URL or the route's remembered preference.
 */
export function workspaceNavigationInfo(
  mode: WorkspaceOpenMode,
): Record<string, unknown> {
  return { [WORKSPACE_OPEN_MODE_INFO_KEY]: mode };
}

export function workspaceOpenModeFromInfo(info: unknown): WorkspaceOpenMode | null {
  if (!info || typeof info !== 'object') return null;
  const mode = (info as Record<string, unknown>)[WORKSPACE_OPEN_MODE_INFO_KEY];
  return mode === 'windowed' || mode === 'docked-right' ? mode : null;
}

/** The shell and Composer must derive routed Workspace state from the URL. */
export function hasRoutedWorkspaceCard(url: string): boolean {
  const path = workspacePath(url);
  return path !== '/' && path !== '';
}

function workspacePath(url: string): string {
  return url.split('?')[0].split('#')[0];
}
